export default __webpack_public_path__ + "static/media/17.da3985cb.gif";